/**
 * Per-user persistence for the main navigation sidebar state:
 * - `open`      — whether the drawer is expanded (restored after a full browser reload;
 *                 it already survives in-app navigation).
 * - `autoClose` — the "Sulge automaatselt" (auto-close) switch. This must be persisted
 *                 together with `open`: the main drawer has no manual toggle, it is only
 *                 opened/closed by hover while auto-close is on, so restoring a collapsed
 *                 drawer without restoring the auto-close switch would leave the menu
 *                 stuck collapsed with no way to reopen it.
 *
 * All reads/writes are best-effort: any localStorage failure falls back to the default.
 */
const SIDEBAR_OPEN_PREFIX = 'app:sidebarOpen:';
const SIDEBAR_AUTO_CLOSE_PREFIX = 'app:sidebarAutoClose:';
const storageKey = (prefix, userId) => `${prefix}${userId ?? 'anonymous'}`;
const readBool = (prefix, userId, fallback) => {
    try {
        const raw = localStorage.getItem(storageKey(prefix, userId));
        return raw === null ? fallback : raw === '1';
    }
    catch (_e) {
        return fallback;
    }
};
const writeBool = (prefix, userId, value) => {
    try {
        localStorage.setItem(storageKey(prefix, userId), value ? '1' : '0');
    }
    catch (_e) {
        // localStorage unavailable — persistence is best-effort, ignore.
    }
};
export const readSidebarOpen = (userId, fallback = true) => readBool(SIDEBAR_OPEN_PREFIX, userId, fallback);
export const writeSidebarOpen = (userId, value) => writeBool(SIDEBAR_OPEN_PREFIX, userId, value);
export const readSidebarAutoClose = (userId, fallback = false) => {
    return readBool(SIDEBAR_AUTO_CLOSE_PREFIX, userId, fallback);
};
export const writeSidebarAutoClose = (userId, value) => {
    writeBool(SIDEBAR_AUTO_CLOSE_PREFIX, userId, value);
};
